import React from 'react';
import { useFormLocked } from 'components/ui/FormLock';

interface IChipButtonProps {
  pressed: boolean;
  className?: string;
  disabled?: boolean;
  onClick: () => void;
  children: React.ReactNode;
}

export default function ChipButton({
  pressed,
  className,
  disabled = false,
  onClick,
  children,
}: IChipButtonProps) {
  const locked = useFormLocked();
  const off = disabled || locked;

  return (
    <button
      type="button"
      aria-pressed={pressed}
      className={className}
      disabled={off}
      onClick={() => {
        if (off) return;
        onClick();
      }}
    >
      {children}
    </button>
  );
}
